import {
  Box,
  Flex,
  IconButton,
  Text,
  Heading,
  useDisclosure
} from '@chakra-ui/react'
import { FC, useCallback, useMemo, useState } from 'react'
import { BiExpandAlt } from 'react-icons/bi'
import { useImmer } from 'use-immer'

import LayoutEmpty from '@component/Layout/Empty'
import TableGrid from '@component/Layout/TableGrid'

import { getTableByEndpoint } from '@service/dashboard'

import ChartsLoading from './Loading'

interface OverviewTableProps {
  id: string
  title: string
  subtitle?: string
  endpoint: string
  entity?: string
  headers: any[]
  dataNew?: any[]
  parser: (data: any) => any[]
  parserFooter?: (data: any) => any[]
  isExpandable?: boolean
  isActionFooter?: boolean
  empresasIds: Array<number>
}

const OverviewTableExport: FC<OverviewTableProps> = ({
  title,
  subtitle,
  endpoint,
  parser,
  parserFooter,
  entity,
  headers = null,
  dataNew = [],
  isExpandable = false,
  isActionFooter = false,

  empresasIds
}) => {
  const { onOpen } = useDisclosure()

  const [loading, setLoading] = useState(true)

  const [, updateData] = useImmer([])

  const columns = useMemo(() => {
    if (!headers) {
      return []
    }

    return headers
  }, [headers])

  const getData = useCallback(
    async (
      options = {
        listagem: 15,
        classificacao: true,
        empresasIds: empresasIds
      }
    ) => {
      setLoading(true)
      try {
        const { data: res } = await getTableByEndpoint(endpoint, options)
        const { data } = res

        updateData(draft => {
          return draft.filter((row: any) => !!row.delete).concat(data)
        })
      } catch {}

      setLoading(false)
    },
    [updateData, endpoint, empresasIds]
  )

  const handleOpen = () => {
    onOpen()
    getData({
      listagem: 0,
      empresasIds: empresasIds
    })
  }

  // useEffect(() => {
  //   switch (entity) {
  //     case 'vendas':
  //       if (dataTable.length === 0) {
  //         getDataTable(empresasIds, endpoint, entity)
  //         updateData(dataTable)
  //         setLoading(false)
  //       }
  //       break
  //     case 'encomenda':
  //       if (dataTable.length === 0) {
  //         getDataTable(empresasIds, endpoint, entity)
  //         updateData(dataEncomenda)
  //         setLoading(false)
  //       }
  //       break
  //     case 'slsf':
  //       if (dataTable.length === 0) {
  //         getDataTable(empresasIds, endpoint, entity)
  //         updateData(dataSlsf)
  //         setLoading(false)
  //       }
  //       break
  //     case 'semVendas':
  //       if (dataTable.length === 0) {
  //         getDataTable(empresasIds, endpoint, entity)
  //         updateData(dataSemVendas)
  //         setLoading(false)
  //       }
  //       break
  //     case 'estoque':
  //       if (dataTable.length === 0) {
  //         getDataTable(empresasIds, endpoint, entity)
  //         updateData(dataEstoqueExcesso)
  //         setLoading(false)
  //       }
  //       break
  //     case 'carteiraFornecedor':
  //       if (dataTable.length === 0) {
  //         getDataTable(empresasIds, endpoint, entity)
  //         updateData(dataCarteiraFornecedor)
  //         setLoading(false)
  //       }
  //       break
  //     default:
  //       getData()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [empresasIds])

  return (
    <Box p={6} mx={3} mb={2} bg="white" borderRadius="8px" boxShadow="sm">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        pb={!subtitle ? '21.4px' : 0}
        mb={6}
      >
        <Box>
          <Heading size="lg">{title}</Heading>
          {subtitle && (
            <Text fontSize="sm" color="gray.600">
              {subtitle}
            </Text>
          )}
        </Box>
        {isExpandable && (
          <IconButton
            size="sm"
            variant="solid"
            onClick={handleOpen}
            isDisabled={loading}
            aria-label="Expandir"
            icon={<BiExpandAlt />}
          />
        )}
      </Flex>

      <>
        {(() => {
          return (
            <ChartsLoading isLoaded={true}>
              {dataNew.length > 0 ? (
                <>
                  <TableGrid
                    id="alert-followUp"
                    headers={columns}
                    entity={entity}
                    data={parser(dataNew).slice(0, 15)}
                    isResizable={false}
                    dataFooter={isActionFooter ? parserFooter(dataNew) : null}
                    isFooter={isActionFooter}
                    height={String(dataNew.length * 40) + 'px'}
                  />
                </>
              ) : (
                <LayoutEmpty type="homeGrid" title="Nada encontrado!" />
              )}
            </ChartsLoading>
          )
          // if (entity === 'vendas') {
          //   return (
          //     <ChartsLoading isLoaded={!loadingTable}>
          //       {dataTable.length > 0 ? (
          //         <TableGrid
          //           id={id}
          //           headers={columns}
          //           data={parser(dataTable).slice(0, 15)}
          //           isResizable={false}
          //           height={String(dataTable.length * 40) + 'px'}
          //         />
          //       ) : (
          //         <LayoutEmpty type="homeGrid" title="Nada encontrado!" />
          //       )}
          //     </ChartsLoading>
          //   )
          // } else if (entity === 'encomenda') {
          //   return (
          //     <ChartsLoading isLoaded={!loadingEncomenda}>
          //       {dataEncomenda.length > 0 ? (
          //         <TableGrid
          //           id={id}
          //           headers={columns}
          //           data={parser(dataEncomenda).slice(0, 15)}
          //           isResizable={false}
          //           height={String(dataEncomenda.length * 40) + 'px'}
          //         />
          //       ) : (
          //         <LayoutEmpty type="homeGrid" title="Nada encontrado!" />
          //       )}
          //     </ChartsLoading>
          //   )
          // } else if (entity === 'slsf') {
          //   return (
          //     <ChartsLoading isLoaded={!loadingSlfp}>
          //       {dataSlsf.length > 0 ? (
          //         <TableGrid
          //           id={id}
          //           headers={columns}
          //           data={parser(dataSlsf).slice(0, 15)}
          //           isResizable={false}
          //           height={String(dataSlsf.length * 40) + 'px'}
          //         />
          //       ) : (
          //         <LayoutEmpty type="homeGrid" title="Nada encontrado!" />
          //       )}
          //     </ChartsLoading>
          //   )
          // } else if (entity === 'semVendas') {
          //   return (
          //     <ChartsLoading isLoaded={!loadingSemVendas}>
          //       {dataSemVendas.length > 0 ? (
          //         <TableGrid
          //           id={id}
          //           headers={columns}
          //           data={parser(dataSemVendas).slice(0, 15)}
          //           isResizable={false}
          //           height={'320px'}
          //         />
          //       ) : (
          //         <LayoutEmpty type="homeGrid" title="Nada encontrado!" />
          //       )}
          //     </ChartsLoading>
          //   )
          // } else if (entity === 'estoque') {
          //   return (
          //     <ChartsLoading isLoaded={!loadingEstoque}>
          //       {dataEstoqueExcesso.length > 0 ? (
          //         <TableGrid
          //           id={id}
          //           headers={columns}
          //           data={parser(dataEstoqueExcesso).slice(0, 15)}
          //           isResizable={false}
          //           height={String(dataEstoqueExcesso.length * 40) + 'px'}
          //         />
          //       ) : (
          //         <LayoutEmpty type="homeGrid" title="Nada encontrado!" />
          //       )}
          //     </ChartsLoading>
          //   )
          // } else if (entity === 'carteiraFornecedor') {
          //   return (
          //     <ChartsLoading isLoaded={!loadingCarteira}>
          //       {dataCarteiraFornecedor.length > 0 ? (
          //         <TableGrid
          //           id={id}
          //           headers={columns}
          //           data={parser(dataCarteiraFornecedor).slice(0, 15)}
          //           isResizable={false}
          //           height={String(dataCarteiraFornecedor.length * 40) + 'px'}
          //         />
          //       ) : (
          //         <LayoutEmpty type="homeGrid" title="Nada encontrado!" />
          //       )}
          //     </ChartsLoading>
          //   )
          // }
        })()}
      </>
    </Box>
  )
}

export default OverviewTableExport
